<template>
  <v-container fluid class="ma-0">
    <v-row class="ma-0">
      <v-col cols="12" class="pa-0">
        <v-tabs v-model="tabs" class="mb-0" center-active show-arrows background-color="transparent">
          <v-tab v-if="Object.keys(rechnungen).length === 0">Keine Rechnungen vorhanden</v-tab>
          <v-tab v-for="jahr in jahre" :key="jahr">{{ jahr }}</v-tab>
          <v-spacer></v-spacer>
          <v-btn text class="ma-2 primary" v-if="status === 'Entwurf SEPA'" @click="showSendRechnungen = true">
            <v-icon>send</v-icon>
            Alle versenden und SEPA generieren
          </v-btn>
        </v-tabs>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-card outlined>
          <v-tabs-items v-model="tabs" class="transparent">
            <v-tab-item v-for="(jahr, index) in rechnungen" :key="index">
              <v-data-table
                ref="rechnungenTabelle"
                dense
                :height="sideHeight"
                :headers="headers"
                :items="jahr.rechnungen"
                :search="search"
                fixed-header
                :items-per-page="100"
                :page.sync="page"
                @page-count="pageCount = $event"
                :hide-default-header="$vuetify.breakpoint.xsOnly"
                no-data-text="Keine Rechnungen vorhanden"
                :show-select="isSelect"
                hide-default-footer
              >
                <template v-slot:header="{ item }">
                  <tr class="hidden-sm-and-up">
                    <th></th>
                    <th>Nummer</th>
                    <th>Bundesbruder</th>
                    <th>Betrag</th>
                    <th>Status</th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr @dblclick="(selectRechnung = item) && (showRechnung = true)">
                    <td width="20px" v-if="isSelect && checkIndex(item.id)" class="pr-0">
                      <v-btn icon @click="addSelect(item.id)"><v-icon>check_box_outline_blank</v-icon></v-btn>
                    </td>
                    <td width="20px" v-if="isSelect && !checkIndex(item.id)" class="pr-0">
                      <v-btn icon @click="addSelect(item.id)"><v-icon>check_box</v-icon></v-btn>
                    </td>
                    <td width="100px" v-if="item.status === 'Mahnung' || item.status === 'Gemahnt überfällig'">
                      <v-chip label small outlined color="red">{{ item.mahnstufe }}. {{ item.status }}</v-chip>
                    </td>
                    <td width="100px" v-else>
                      <v-chip label small outlined>{{ item.status }}</v-chip>
                    </td>
                    <td>{{ item.rechnungsnummer }}</td>
                    <td>{{ item.rechnung_titel }}</td>
                    <td width="220px">
                      {{ item.kontakt }}
                    </td>
                    <td width="120px" class="text-right">
                      {{ $filters.money(item.summe) }}
                    </td>
                    <td width="170px" class="hidden-xs-only">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{ $filters.date(item.rechnung_datum, "DD.MM.YYYY") }}</span>
                        </template>
                        <span>
                          Gestellt am:
                          {{ $filters.date(item.rechnung_datum, "DD.MM.YYYY") }}
                          <br />
                          Zahlbar bis:
                          {{ $filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY") }}
                        </span>
                      </v-tooltip>
                    </td>
                    <td>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn size="small" icon variant="flat" v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav dense>
                          <v-list-item v-if="item.status === 'Entwurf'" @click="neuerStatus(item, 'Offen')">
                            <v-list-item-icon><v-icon>send</v-icon></v-list-item-icon>
                            <v-list-item-title>Rechnungen versenden</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="
                              item.status === 'Offen' ||
                              item.status === 'Versendet' ||
                              item.status === 'Überfällig' ||
                              item.status === 'Gemahnt' ||
                              item.status === 'Gemahnt überfällig'
                            "
                            @click="neuerStatus(item, 'Gezahlt')"
                          >
                            <v-list-item-icon><v-icon>check</v-icon></v-list-item-icon>
                            <v-list-item-title>Rechnung als gezahlt markieren</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.status === 'Entwurf SEPA'" @click="showSendRechnungen = true">
                            <v-list-item-icon><v-icon>send</v-icon></v-list-item-icon>
                            <v-list-item-title>Alle Rechnungen versenden und SEPA generieren</v-list-item-title>
                          </v-list-item>
                          <buttonRechnungDownload type="list" icon="download" :rechnung="item" />
                          <v-list-item @click="(showDeleteRechnung = true) && (deleteRechnungID = item.id)">
                            <v-list-item-icon><v-icon>delete</v-icon></v-list-item-icon>
                            <v-list-item-title>Rechnung löschen</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="item.status === 'Entwurf'" @click="alleEntwurfNeuerStatus()">
                            <v-list-item-icon><v-icon>send</v-icon></v-list-item-icon>
                            <v-list-item-title>Alle Entwurf-Rechnungen versenden</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template v-slot:footer>
                  <v-divider></v-divider>
                  <v-row no-gutters>
                    <v-btn v-if="selected.length > 0" text @click="showMehrereBearbeiten = true">bearbeiten</v-btn>
                    <v-btn v-if="selected.length > 0" text @click="sepaGenerieren(selected)"
                      >SEPA-Datei generieren</v-btn
                    >
                    <v-spacer></v-spacer>
                    <div class="subtitle-2 mt-2 mb-2 mr-6">Summe: {{ $filters.money(summe) }}</div>
                  </v-row>
                  <v-divider></v-divider>
                  <v-pagination :total-visible="7" v-model="page" :length="pageCount"></v-pagination>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <dialogRechnung
      :visible.sync="showRechnung"
      :rechnungid="selectRechnung.id"
      @close="showRechnung = false"
    ></dialogRechnung>

    <dialogDelete
      :visible.sync="showDeleteRechnung"
      title="Rechnung löschen"
      message="Willst du diese Rechnung wirklich löschen?"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteRechnung()"
      @closeFalse="showDeleteRechnung = false"
    >
    </dialogDelete>

    <dialogDelete
      :visible.sync="showDeleteMehrereRechnung"
      :title="selected.length + ' Rechnungen löschen'"
      :message="'Willst du wirklich ' + selected.length + ' Rechnung wirklich löschen?'"
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="loescheMehrere()"
      @closeFalse="showDeleteMehrereRechnung = false"
    >
    </dialogDelete>

    <v-dialog
      v-model="showSendRechnungen"
      width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          Rechnungen mit SEPA versenden
          <v-spacer></v-spacer>
          <v-btn icon @click="showSendRechnungen = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text>
          <v-stepper v-model="stepperSendRechnungen" vertical flat>
            <v-stepper-step :complete="stepperSendRechnungen > 1" step="1"> SEPA-Datei generieren </v-stepper-step>

            <v-stepper-content step="1">
              <v-card flat>
                <v-card-text>
                  Hier werden alle Rechnungen dieser Ansicht in einer SEPA-Datei zusammengefasst. Die Datei wird direkt
                  heruntergeladen und in der Datenbank für einen späteren Abruf gespeichert.
                  <br /><br />
                  Auch wenn das Datum in "Zahlbar bis" unterschiedlich ist, werden alle Rechnungen zum gleichen Datum
                  eingezogen. Das Datum kann dann auf der Seite der Bank angepasst werden.
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="showSendRechnungen = false">Abbrechen</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="loading" @click="sepaGenerieren()">SEPA Generieren</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepperSendRechnungen > 2" step="2"> Rechnungen versenden </v-stepper-step>

            <v-stepper-content step="2">
              <v-card flat>
                <v-card-text>
                  Hier können alle Rechnungen die gerade als SEPA-Datei zusammengefasst wurden zusammen versendet
                  werden. Der Versand kann längere Zeit dauern. (Dauer ca 30 Rechnungen/Minute)
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="stepperSendRechnungen = 1">Zurück</v-btn>
                  <v-spacer></v-spacer>
                  <v-progress-linear
                    v-if="loading"
                    :value="progressSendSepa"
                    height="30"
                    class="rounded ml-8 mr-2"
                    color="primary"
                    >{{ progressSendSepa }}%</v-progress-linear
                  >
                  <v-btn color="primary" :loading="loading" @click="sepaRechnungenVersenden()">Versenden</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepperSendRechnungen > 3" step="3"> Abgeschlossen </v-stepper-step>

            <v-stepper-content step="3">
              <v-card flat>
                <v-card-text> Fertig. Du kannst das Fenster jetzt schließen. </v-card-text>
                <v-card-actions>
                  <v-btn text @click="stepperSendRechnungen = 2">Zurück</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="showSendRechnungen = false">Schließen</v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showMehrereBearbeiten"
      width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          {{ selected.length }} Rechnungen bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showMehrereBearbeiten = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12"> Hier können für alle Rechnungen gleichzeitig bestimmte Felder angepasst werden. </v-col>
            <v-col cols="6">
              <v-text-field outlined label="Titel" v-model="bearbeiteteFelder.rechnung_titel"> </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Rechnungsdatum"
                v-model="bearbeiteteFelder.rechnung_datum"
                hint="Format: 2022-03-17"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Rechnung Zahlbar bis"
                v-model="bearbeiteteFelder.rechnung_zahlbar_bis"
                hint="Format: 2022-03-17"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Status"
                v-model="bearbeiteteFelder.status"
                hint="Möglich: Entwurf, Entwurf SEPA, Offen"
              >
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12">
              <v-textarea
                outlined
                label="Freitext"
                v-model="bearbeiteteFelder.rechnung_freitext"
                hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>" 
                rows="5"
                auto-grow
              >
              </v-textarea>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="showDeleteMehrereRechnung = true" class="red">Löschen</v-btn>
          <v-btn text @click="showMehrereBearbeiten = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="bearbeiteMehrere()" class="primary">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import JSPDF from "jspdf";
  export default {
    props: ["status", "search", "kasse", "showFilter"],
    data() {
      return {
        loading: false,
        selected: [],
        showRechnung: false,
        showSendRechnungen: false,
        selectRechnung: [],
        neuStatus: "",
        summeVon: "0",
        summeBis: "2000",
        bearbeiteteFelder: {},
        showMehrereBearbeiten: false,
        statusAuswahl: ["Offen", "Gezahlt"],
        progressSendSepa: 0,
        headers: [
          { text: "Status", value: "status" },
          { text: "Nr.", value: "rechnungsnummer" },
          { text: "Titel", value: "rechnung_titel" },
          { text: "Kontakt", value: "bbr" },
          { text: "Summe", align: "right", value: "summe" },
          { text: "Rechnungsdatum", value: "rechnung_datum" },
          { text: "", value: "" },
        ],
        showDeleteRechnung: false,
        showDeleteMehrereRechnung: false,
        deleteRechnungID: "",
        page: 1,
        pageCount: 0,
        rechnungenSummen: [0, 0, 0, 0, 0],
        stepperSendRechnungen: 1,
        logoUrl: null,
        tabs: 0,
      };
    },
    mounted() {
      this.loadLogo();
    },
    computed: {
      summe() {
        return this.rechnungen[this.tabs].rechnungen.reduce((total, item) => total + item.summe, 0);
      },
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      isSelect() {
        // return (this.status === 'Entwurf' || this.status === 'Entwurf SEPA')
        return true;
      },
      settings() {
        return this.$store.getters["einstellungen/einstellung"]("allgemein");
      },
      rechnungen() {
        let rechnungen;
        this.jahre = [];
        const jahreMap = new Map(); // Map zum Gruppieren von Rechnungen nach Jahren

        if (this.status === "Alle") {
          rechnungen = this.$store.getters["rechnungen/rechnungenKasse"](this.kasse);
          this.rechnungenSummen = [0, 0, 0, 0, 0, 0, 0];
          rechnungen.forEach((rechnung) => {
            if (rechnung.summe === undefined) {
              rechnung.summe = 0;
              rechnung.positionen.forEach((position) => {
                rechnung.summe += parseFloat(position.betrag);
              });
            }
            if (rechnung.status === "Entwurf") {
              this.rechnungenSummen[0] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
            if (rechnung.status === "Entwurf SEPA") {
              this.rechnungenSummen[1] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
            if (rechnung.status === "Offen") {
              this.rechnungenSummen[2] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
            if (rechnung.status === "Überfällig") {
              this.rechnungenSummen[3] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
            if (rechnung.status === "Mahnung") {
              this.rechnungenSummen[4] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
            if (rechnung.status === "Gemahnt überfällig") {
              this.rechnungenSummen[5] += parseFloat(rechnung.summe);
              this.rechnungenSummen[6] += parseFloat(rechnung.summe);
            }
          });
        } else {
          rechnungen = this.$store.getters["rechnungen/statusRechnungenKasse"](this.status, this.kasse);
        }

        rechnungen.forEach((rechnung) => {
          let zahldate = new Date(rechnung.rechnung_zahlbar_bis);
          let today = new Date();
          let kontakt = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
          rechnung.kontakt = kontakt.vorname + " " + kontakt.nachname;
          if (rechnung.status === "Offen" && today > zahldate) {
            rechnung.status = "Überfällig";
            this.$store.dispatch("rechnungen/updateRechnungData", rechnung);
            console.log("rechnung update");
          }
          if (rechnung.status === "Mahnung" && today > zahldate) {
            rechnung.status = "Gemahnt überfällig";
            this.$store.dispatch("rechnungen/updateRechnungData", rechnung);
            console.log("rechnung update");
          }
          if (rechnung.summe === undefined) {
            rechnung.summe = 0;
            rechnung.positionen.forEach((position) => {
              rechnung.summe += parseFloat(position.betrag);
            });
          }
          if (rechnung.rechnungssumme < this.summeVon || rechnung.rechnungssumme > this.summeBis) {
            rechnungen.splice(rechnungen.indexOf(rechnung), 1);
          }

          if (rechnung.rechnung_zahlbar_bis) {
            const year = new Date(rechnung.rechnung_zahlbar_bis).getFullYear();
            if (!jahreMap.has(year)) {
              jahreMap.set(year, []);
            }
            jahreMap.get(year).push(rechnung);
          }
        });

        this.jahre = Array.from(jahreMap.keys()).sort((a, b) => b - a);
        const jahre = this.jahre.map((jahr) => ({
          jahr,
          rechnungen: jahreMap.get(jahr),
        }));
        return jahre;
      },
      sideHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 429px)";
          case "sm":
            return "calc(100vh - 429px)";
          case "md":
            return "calc(100vh - 429px)";
          case "lg":
            return "calc(100vh - 429px)";
          case "xl":
            return "calc(100vh - 42px)";
        }
      },
    },
    methods: {
      bearbeiteMehrere() {
        this.selected.forEach((id) => {
          let rechnung = this.$store.getters["rechnungen/rechnung"](id);
          if (this.bearbeiteteFelder.rechnung_titel) {
            rechnung.rechnung_titel = this.bearbeiteteFelder.rechnung_titel;
          }
          if (this.bearbeiteteFelder.rechnung_datum) {
            rechnung.rechnung_datum = this.bearbeiteteFelder.rechnung_datum;
          }
          if (this.bearbeiteteFelder.rechnung_zahlbar_bis) {
            rechnung.rechnung_zahlbar_bis = this.bearbeiteteFelder.rechnung_zahlbar_bis;
          }
          if (this.bearbeiteteFelder.status) {
            rechnung.status = this.bearbeiteteFelder.status;
          }
          // if (this.bearbeiteteFelder.rechnung_freitext) {
          //   console.log('Freitext')
          //   let rechnungFreitext = this.ersetzeText(rechnung.rechnung_freitext, rechnung)
          //   rechnung.rechnung_freitext = rechnungFreitext
          //   console.log(rechnung)
          // }
          this.$store.dispatch("rechnungen/updateRechnungData", rechnung);
        });
        this.selected = [];
        this.bearbeiteteFelder = {};
        this.showMehrereBearbeiten = false;
      },
      loescheMehrere() {
        this.selected.forEach((id) => {
          this.$store.dispatch("rechnungen/deleteRechnungData", id);
        });
        this.selected = [];
        this.showDeleteMehrereRechnung = false;
        this.bearbeiteteFelder = {};
        this.showMehrereBearbeiten = false;
      },
      ersetzeText(text, rechnung) {
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          summe = parseFloat(summe) + parseFloat(position.betrag);
        });
        text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
        text = text.replace(
          "<<Rechnungsdatum>>",
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
        text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
        text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
        text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
        text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
        text = text.replace(
          "<<Zahlbar_bis>>",
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        return text;
      },
      checkIndex(id) {
        if (this.selected.indexOf(id) >= 0) {
          return false;
        } else {
          return true;
        }
      },
      addSelect(id) {
        if (this.selected.indexOf(id) >= 0) {
          this.selected.splice(this.selected.indexOf(id), 1);
        } else {
          this.selected.push(id);
        }
      },
      alleEntwurfNeuerStatus() {
        this.rechnungen[this.tabs].rechnungen.forEach((rechnung) => {
          if (rechnung.status === "Entwurf") {
            this.neuerStatus(rechnung, "Offen");
          }
        });
      },
      neuerStatus(selectRechnung, status) {
        if (selectRechnung.farbe === undefined) {
          selectRechnung.farbe = "";
        }
        if (
          (selectRechnung.status === "Entwurf" && status !== "Entwurf") ||
          (selectRechnung.status === "Entwurf SEPA" && status !== "Entwurf SEPA")
        ) {
          this.rechnungVersenden(selectRechnung);
        }
        if (status !== "Gezahlt") {
          selectRechnung.gezahlt_datum = new Date();
        }
        if (status === "") {
          return;
        } else {
          selectRechnung.status = status;
          this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
        }
      },
      sepaGenerieren(selected) {
        console.log(this.rechnungen[this.tabs].rechnungen);
        let rechnungen = [];
        if (selected === undefined) {
          rechnungen = this.rechnungen[this.tabs].rechnungen;
        } else {
          selected.forEach((item) => {
            rechnungen.push(this.rechnungen[this.tabs].rechnungen.find((rechnung) => rechnung.id === item));
          });
        }
        this.loading = true;
        let anzahlRechnungen = rechnungen.length;
        let summeRechnungen = 0;
        rechnungen.forEach((rechnung) => {
          console.log(rechnung);
          console.log(rechnung.summe);
          summeRechnungen = summeRechnungen + parseFloat(parseFloat(rechnung.summe).toFixed(2));
        });
        summeRechnungen = summeRechnungen.toFixed(2);
        let kassenInfo = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnungen[0].kasse];
        kassenInfo.IBAN = kassenInfo.IBAN.replace(/ /g, "");
        let nachrichtenID = "ID-1863-" + new Date().getTime();
        let nachrichtenErstellung = new Date().toISOString().substr(0, 24);
        let rechnungZahlbarBis = rechnungen[0].rechnung_zahlbar_bis;
        let xmltext;
        try {
          xmltext =
            "<?xml version='1.0' encoding='UTF-8'?>\n" +
            "<Document xmlns='urn:iso:std:iso:20022:tech:xsd:pain.008.001.02' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xsi:schemaLocation='urn:iso:std:iso:20022:tech:xsd:pain.008.001.02 pain.008.001.02.xsd'><CstmrDrctDbtInitn>\n" +
            "\t<GrpHdr>\n" +
            "\t\t<MsgId>" +
            nachrichtenID +
            "</MsgId>\n" +
            "\t\t<CreDtTm>" +
            nachrichtenErstellung +
            "</CreDtTm>\n" +
            "\t\t<NbOfTxs>" +
            anzahlRechnungen +
            "</NbOfTxs>\n" +
            "\t\t<CtrlSum>" +
            summeRechnungen +
            "</CtrlSum>\n" +
            "\t\t<InitgPty>\n" +
            "\t\t\t<Nm>" +
            kassenInfo.kontoname +
            "</Nm>\n" +
            "\t\t</InitgPty>\n" +
            "\t</GrpHdr>\n" +
            "\t<PmtInf>\n" +
            "\t\t<PmtInfId>" +
            nachrichtenID +
            "</PmtInfId>\n" +
            "\t\t<PmtMtd>DD</PmtMtd>\n" +
            "\t\t<BtchBookg>true</BtchBookg>\n" +
            "\t\t<NbOfTxs>" +
            anzahlRechnungen +
            "</NbOfTxs>\n" +
            "\t\t<CtrlSum>" +
            summeRechnungen +
            "</CtrlSum>\n" +
            "\t\t<PmtTpInf>\n" +
            "\t\t\t<SvcLvl>\n" +
            "\t\t\t\t<Cd>SEPA</Cd>\n" +
            "\t\t\t</SvcLvl>\n" +
            "\t\t\t<LclInstrm>\n" +
            "\t\t\t\t<Cd>CORE</Cd>\n" +
            "\t\t\t</LclInstrm>\n" +
            "\t\t\t<SeqTp>RCUR</SeqTp>\n" +
            "\t\t</PmtTpInf>\n" +
            "\t\t<ReqdColltnDt>" +
            rechnungZahlbarBis +
            "</ReqdColltnDt>\n" +
            "\t\t<Cdtr>\n" +
            "\t\t\t<Nm>" +
            kassenInfo.kontoname +
            "</Nm>\n" +
            "\t\t</Cdtr>\n" +
            "\t\t<CdtrAcct>\n" +
            "\t\t\t<Id>\n" +
            "\t\t\t\t<IBAN>" +
            kassenInfo.IBAN +
            "</IBAN>\n" +
            "\t\t\t</Id>\n" +
            "\t\t</CdtrAcct>\n" +
            "\t\t<CdtrAgt>\n" +
            "\t\t\t<FinInstnId>\n" +
            "\t\t\t\t<BIC>" +
            kassenInfo.BIC +
            "</BIC>\n" +
            "\t\t\t</FinInstnId>\n" +
            "\t\t</CdtrAgt>\n" +
            "\t\t<ChrgBr>SLEV</ChrgBr>\n" +
            "\t\t<CdtrSchmeId>\n" +
            "\t\t\t<Id>\n" +
            "\t\t\t\t<PrvtId>\n" +
            "\t\t\t\t\t<Othr>\n" +
            "\t\t\t\t\t\t<Id>" +
            kassenInfo.glaubigerID +
            "</Id>\n" +
            "\t\t\t\t\t\t<SchmeNm>\n" +
            "\t\t\t\t\t\t\t<Prtry>SEPA</Prtry>\n" +
            "\t\t\t\t\t\t</SchmeNm>\n" +
            "\t\t\t\t\t</Othr>\n" +
            "\t\t\t\t</PrvtId>\n" +
            "\t\t\t</Id>\n" +
            "\t\t</CdtrSchmeId>";

          rechnungen.forEach((rechnung) => {
            let bundesbruder = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
            let betrag = parseFloat(rechnung.summe).toFixed(2);
            let EndToEndId = "RBO" + rechnung.rechnungsnummer;
            let MndtId = bundesbruder.mandatsreferenz.replace(/[^A-Z0-9]/g, "");
            let DtOfSgntr = bundesbruder.mandatUnterschriftsdatum;
            let AmdmntInd = "false";
            let BIC = bundesbruder.bic;
            let name = bundesbruder.kontoinhaber;
            let IBAN = bundesbruder.iban.replace(/ /g, "");
            let betreff = (rechnung.rechnung_titel + " " + rechnung.rechnungsnummer).replace(/[^\x00-\x7F]/g, "");
            rechnung.gezahlt_datum = new Date(rechnung.rechnung_zahlbar_bis);
            xmltext =
              xmltext +
              "\n" +
              "\t<DrctDbtTxInf>\n" +
              "\t\t<PmtId>\n" +
              "\t\t\t<EndToEndId>" +
              EndToEndId +
              "</EndToEndId>\n" +
              "\t\t</PmtId>\n" +
              "\t\t<InstdAmt Ccy='EUR'>" +
              betrag +
              "</InstdAmt>\n" +
              "\t\t<DrctDbtTx>\n" +
              "\t\t\t<MndtRltdInf>\n" +
              "\t\t\t\t<MndtId>" +
              MndtId +
              "</MndtId>\n" +
              "\t\t\t\t<DtOfSgntr>" +
              DtOfSgntr +
              "</DtOfSgntr>\n" +
              "\t\t\t\t<AmdmntInd>" +
              AmdmntInd +
              "</AmdmntInd>\n" +
              "\t\t\t</MndtRltdInf>\n" +
              "\t\t</DrctDbtTx>\n" +
              "\t\t<DbtrAgt>\n" +
              "\t\t\t<FinInstnId>\n" +
              "\t\t\t\t<BIC>" +
              BIC +
              "</BIC>\n" +
              "\t\t\t</FinInstnId>\n" +
              "\t\t</DbtrAgt>\n" +
              "\t\t<Dbtr>\n" +
              "\t\t\t<Nm>" +
              name +
              "</Nm>\n" +
              "\t\t</Dbtr>\n" +
              "\t\t<DbtrAcct>\n" +
              "\t\t\t<Id>\n" +
              "\t\t\t\t<IBAN>" +
              IBAN +
              "</IBAN>\n" +
              "\t\t\t</Id>\n" +
              "\t\t</DbtrAcct>\n" +
              "\t\t<RmtInf>\n" +
              "\t\t\t<Ustrd>" +
              betreff +
              "</Ustrd>\n" +
              "\t\t</RmtInf>\n" +
              "\t</DrctDbtTxInf>";
          });

          xmltext = xmltext + "\n" + "\t</PmtInf>\n" + "</CstmrDrctDbtInitn>\n" + "</Document>";
        } catch (err) {
          console.error(err);
          this.$store.state.nachricht.typ = "error";
          this.$store.state.nachricht.nachricht = "Die Erstellung der SEPA-Datei hat nicht geklappt.";
          this.$store.state.nachricht.error = err;
          this.$store.state.nachricht.show = true;
        }
        let filename =
          new Date().toISOString().substr(0, 10) +
          "-" +
          new Date().toISOString().substr(11, 8) +
          "_sepa_" +
          rechnungen[0].kasse +
          ".xml";
        // Generieren und Download der Datei
        let pom = document.createElement("a");
        pom = document.createElement("a");
        let bb = new Blob([xmltext], { type: "text/plain" });
        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);
        pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
        pom.draggable = true;
        pom.classList.add("dragout");
        pom.click();
        this.$store.dispatch("sepa/createEinSepa", {
          date: new Date(),
          xml: xmltext,
          filename: filename,
          summe: summeRechnungen,
          anzahl: anzahlRechnungen,
          kasse: kassenInfo.kontoname,
        });
        this.loading = false;
        this.progressSendSepa = 0;
        this.stepperSendRechnungen = 2;
      },
      sepaRechnungenVersenden() {
        this.loading = true;
        const length = this.rechnungen[this.tabs].rechnungen.length;
        this.rechnungen[this.tabs].rechnungen.forEach((rechnung, index) => {
          setTimeout(() => {
            console.log("send Rechnung (" + (index + 1) + "/" + length + ")");
            this.neuerStatus(rechnung, "Gezahlt");
            this.progressSendSepa = (index / length) * 100;
          }, 1000 * index);
        });
        setTimeout(() => {
          this.loading = false;
          this.stepperSendRechnungen = 3;
        }, 1000 * length);
      },
      rechnungVersenden(rechnung) {
        console.log(rechnung);
        // Mail verschicken
        rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
        let bundesbruder = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        let absender = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        if (bundesbruder.email) {
          this.$store.dispatch("mails/createEinMails", {
            art: "rechnung",
            rechnung,
            von: this.currentBbr,
            to: [bundesbruder.email],
            an: [bundesbruder.id],
            absender: {
              position: this.$route.params.seite,
              name: absender.vorname + " " + absender.nachname,
              vorname: absender.vorname || "",
              nachname: absender.nachname || "",
              adresse: absender.adresse || "",
              plz: absender.plz || "",
              ort: absender.ort || "",
              email: absender.email || "",
              telefon: absender.handy || "",
            },
            message: {
              subject: rechnung.rechnung_titel,
              text: rechnung.rechnung_freitext_code,
            },
            datum: new Date(),
          });
        } else {
          this.printRechnung(rechnung);
          this.$store.state.snackbar = {
            show: true,
            nachricht:
              "Mindestens eine Rechnung wurde heruntergeladen, da keine Mailadresse beim Rechnungsempfänger hinterlegt ist.",
          };
        }
      },
      goToId(id) {
        this.$router.push("/bierwart/rechnungen/" + id);
      },
      deleteRechnung() {
        this.$store.dispatch("rechnungen/deleteRechnungData", this.deleteRechnungID);
        this.showDeleteRechnung = false;
        this.deleteRechnungID = "";
      },
      async loadLogo() {
        try {
          const url = await this.logoImage();
          this.logoUrl = url;
        } catch (error) {
          console.error("Error loading logo:", error);
        }
      },
      async logoImage() {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`;
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL();
          return url;
        } catch (error) {
          console.error(error);
          throw error; // Rethrow the error to be caught in the calling function
        }
      },
      printRechnung(item) {
        let rechnung = item;
        let kasse = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
        let bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        if (this.$vars.verbindung === "rbo") {
          doc.setFillColor(
            this.settings.secondary.rgba.r,
            this.settings.secondary.rgba.g,
            this.settings.secondary.rgba.b
          );
          doc.rect(0, 92, 210, 1, "F");
          let img = new Image();
          img.src = "/static/wappen_512.png";
          doc.addImage(img, 125, 30, 75, 75);
        }
        doc.setFontSize(9);
        doc.text(
          this.settings.name +
            " | " +
            this.settings.strasse +
            " " +
            this.settings.hausnummer +
            " | " +
            this.settings.plz +
            " " +
            this.settings.ort,
          25,
          51
        );
        doc.setFontSize(11);
        if (bbr.titel) {
          doc.text(bbr.anrede + " " + bbr.titel, 25, 61);
        } else {
          doc.text(bbr.anrede, 25, 61);
        }
        doc.text(bbr.vorname + " " + bbr.nachname, 25, 66);
        doc.text(bbr.adresse, 25, 71);
        doc.text(bbr.plz + " " + bbr.ort, 25, 76);
        doc.text(bbr.land, 25, 81);
        doc.setFont("Times", "bold");
        doc.text("Rechnungsnr.", 20, 110);
        doc.text("Datum", 70, 110);
        if (rechnung.rechnung_art === "SEPA") {
          doc.text("Einzug am", 120, 110);
        } else {
          doc.text("Zahlbar bis", 120, 110);
        }
        doc.text("Kasse", 170, 110);
        doc.setFont("Times", "normal");
        doc.text(rechnung.rechnungsnummer, 20, 115);
        doc.text(
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }),
          70,
          115
        );
        doc.text(
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }),
          120,
          115
        );
        doc.text(rechnung.kasse, 170, 115);
        doc.setFont("Times", "bold");
        doc.text(rechnung.rechnung_titel, 210, 125);
        doc.setFont("Times", "normal");
        let lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);
        doc.text(lines1, 20, 130);
        let zeile = 130 + parseInt(parseInt(6) * lines1.length);
        doc.setFont("Times", "bold");
        zeile = parseInt(zeile) + 5;
        doc.text("Pos", 20, zeile);
        doc.text("Beschreibung", 31, zeile);
        doc.text("Betrag", 190, zeile, { align: "right" });
        doc.setFont("Times", "normal");
        zeile = parseInt(zeile) + 2;
        doc.line(20, zeile, 190, zeile);
        zeile = parseInt(zeile) + 6;
        let pos = "1";
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          doc.text(pos, 20, zeile);
          doc.text(position.was, 31, zeile);
          doc.text(parseFloat(position.betrag).toFixed(2) + " €", 190, zeile, {
            align: "right",
          });
          summe = summe + parseFloat(position.betrag);
          zeile = parseInt(zeile) + 10;
          pos = String(parseInt(pos) + 1);
        });
        doc.line(20, zeile - 4, 190, zeile - 4);
        doc.setFont("Times", "bold");
        zeile = parseInt(zeile) + 1;
        doc.text("Summe " + summe.toFixed(2) + " €", 190, zeile, {
          align: "right",
        });
        doc.setFont("Times", "normal");
        zeile = parseInt(zeile) + 2;
        doc.line(159, zeile, 190, zeile);
        zeile = parseInt(zeile) + 1;
        doc.line(159, zeile, 190, zeile);
        doc.setFontSize(9);

        doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
        doc.rect(0, 265, 210, 297, "F");
        doc.setFontSize(10);
        doc.setTextColor(230, 230, 230);
        doc.setFont("Times", "bold");
        doc.text(this.settings.name, 60, 272, { align: "center" });
        doc.setFont("Times", "normal");
        doc.text(rechnung.kasse, 60, 280, { align: "center" });
        doc.text(this.settings.strasse + " " + this.settings.hausnummer, 60, 285, { align: "center" });
        doc.text(this.settings.plz + " " + this.settings.ort, 60, 290, {
          align: "center",
        });
        doc.setFont("Times", "bold");
        doc.text("Bankverbindung", 150, 272, { align: "center" });
        doc.setFont("Times", "normal");
        doc.text(kasse.kontoname, 150, 280, { align: "center" });
        doc.text(kasse.IBAN, 150, 285, { align: "center" });
        doc.text(kasse.BIC, 150, 290, { align: "center" });

        doc.save("Rechnung-" + rechnung.rechnungsnummer + "-" + bbr.nachname + "-" + bbr.vorname + ".pdf");
      },
    },
    errorCaptured(error, vm, info) {
      console.error("Error:", error);
      console.info("Info:", info);
      return false;
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// rechnungenListe.vue?7e609ef8